module.exports = __webpack_public_path__ + "static/poster-90536e3b66e8e01bd25f14be83984063.png";